import { Switch } from '@headlessui/react'
import classnames from 'classnames'

type Props = {
  settingName: string
  flag: boolean
  handleFlag: (active: boolean) => void
  description?: string
  isHighContrast: boolean
  disabled?: boolean
  toggleSlot?: any
}

export const SettingsToggle = ({
  settingName,
  flag,
  handleFlag,
  isHighContrast,
  disabled = false,
  description = '',
  toggleSlot = '',
}: Props) => {
  const switchClasses = classnames(
    'w-14 h-8 flex flex-shrink-0 items-center rounded-full p-1 duration-300 ease-in-out cursor-pointer focus:outline-none',
    {
      'bg-slate-400': !flag && !isHighContrast,
      'bg-slate-500 dark:bg-slate-400': !flag && isHighContrast,
      'bg-indigo-600': flag && !isHighContrast,
      'bg-indigo-600 dark:bg-indigo-500': flag && isHighContrast,
      'opacity-40 pointer-events-none': disabled,
    }
  )

  const switchToggleClasses = classnames(
    'pointer-events-none inline-flex items-center justify-center bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out ring-0',
    {
      'translate-x-6': flag,
    }
  )

  return (
    <Switch.Group>
      <div className="flex items-center justify-between py-2">
        <Switch.Label className="mr-4 inline-flex flex-col items-start text-gray-900 dark:text-gray-100">
          <span
            className={classnames('inline-block font-semibold', {
              'mb-1': description,
            })}
          >
            {settingName}
          </span>
          {description && (
            <span className="inline-block max-w-[85%] text-left text-xs text-gray-500 dark:text-gray-400">
              {description}
            </span>
          )}
        </Switch.Label>
        <Switch checked={flag} onChange={handleFlag} className={switchClasses}>
          <span aria-hidden="true" className={switchToggleClasses}>
            {toggleSlot}
          </span>
        </Switch>
      </div>
    </Switch.Group>
  )
}
